<template>
	<article class="small-12 flex lateResidents sidebarWidget animated fadeIn">
        <div class="small-12 columns wrap borderRadius8">
            <div class="small-12 title flex vertical-align">
                <h3 class="small-7 flex vertical-align">Late This Month</h3>
                <div class="small-5 flex vertical-align justify-right">
                    <div class="totalWrap borderRadius50 small-12 flex vertical-align">
                        <span class="round totalLate flex vertical-align justify-center">{{ totalLate }}</span>
                        <p class="auto">Total</p>
                    </div>
                </div>
            </div>
            <div class="small-12 lateProgress">
                <div class="small-12 percentLabel flex justify-between">
                    <h6>Percentage of Residents</h6>
                    <p>{{ percentageLate }}%</p>
                </div>
                <meter-gauge :colorClass="'bgWhite'" :percentage="percentageLate"/>
            </div>
            <ul class="small-12 float-left flex" v-if="late_invoices.length > 0">
                <li class="small-12">
                    <p>Residents</p>
                </li>
                <li class="small-12 animated fadeIn" v-for="(document, index) in late_invoices" :key="index" @click="navigateToResidentPage(document)">
                    <router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: document.resident.id } }" class="small-12 columns borderRadius8 lateResident flex vertical-align float-left">
                        <div class="small-4 flex vertical-align justify-center pic">
                            <span class="round check"></span>
                            <picture class="round flex vertical-align justify-center">
                                {{ document.resident.attributes.contact_information.first_name | abbreviateName }}{{ document.resident.attributes.contact_information.last_name | abbreviateName }}
                            </picture>
                        </div>
                        <div class="small-8 residentDeets flex">
                            <span class="small-12">Name</span>
                            <p class="small-12">{{ document.resident.attributes.contact_information.first_name }} {{ document.resident.attributes.contact_information.last_name }}</p>
                        </div>
                    </router-link>
                </li>
            </ul>
            <ul class="small-12 float-left flex" v-else>
                <li class="small-12">
                    <p>Residents</p>
                </li>
                <li class="small-12 animated fadeIn">
                    <div class="small-12 columns borderRadius8 lateResident flex vertical-align empty flex justify-center">
                        <p>No late residents at this time.</p>
                    </div>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>

    // Import the filters
    import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'

    // Import the components
    import MeterGauge from '@/components/framework/helpers/MeterGauge.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LateResidents',

		/*
		**  Register the components
		*/

		components: {

			MeterGauge

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			late_invoices: {
                type: Array,
                default: () => []
            },

            all_invoices: {
                type: Array,
                default: () => []
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

            //

		},

		/*
		**  Set the computed props
		*/

		computed: {

			totalLate: function() {

                return this.late_invoices.length;

            },

            percentageLate: function() {
                
                if (this.all_invoices.length > 0 && this.late_invoices.length > 0) {

                    let percent = (this.late_invoices.length / this.all_invoices.length * 100).toFixed(0);

                    return Number(percent);

                }

                return 0;

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>